export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalDeleteAccount.vue?vue&type=template&id=67f90feb"


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/profiles/components/ModalDeleteAccount.vue?vue&type=template&id=67f90feb
// module id = 575
// module chunks = 0